import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ContractChangeTracker } from '../../change_trackers';
import { InputBaseModel } from '../../models';
import { ContractComparisonPanel } from '../../types';
import { getVisibleComparisonInputIds } from '../../misc';
import { ContractComparisonPanelRenderer } from '..';
import { useAppStore } from '../../stores';

type InputLookupCallback = (inputId: string) => InputBaseModel | undefined;

interface Props {
    nodeId: string;
    panels: ContractComparisonPanel[];
    contractChangeTracker: ContractChangeTracker;
    getNewInputById: InputLookupCallback;
    getPreviousInputById: InputLookupCallback;
}

const ContractComparisonPanelsRenderer: React.FC<Props> = ({
    nodeId,
    panels,
    contractChangeTracker,
    getNewInputById,
    getPreviousInputById
}) => {
    const { contractComparisonStore } = useAppStore();

    const visiblePanels = panels.filter(panel => {
        const inputGroupChangeTracker = contractChangeTracker.getInputGroupChangeTracker(panel.id);

        if (!inputGroupChangeTracker) {
            return false;
        }

        return (
            getVisibleComparisonInputIds(
                contractComparisonStore.selectedFilter,
                panel.inputIds,
                inputGroupChangeTracker
            ).length > 0
        );
    });

    if (!visiblePanels.length) {
        return null;
    }

    return (
        <>
            {visiblePanels.map(panel => {
                const inputGroupChangeTracker = contractChangeTracker.getInputGroupChangeTracker(panel.id);

                if (!inputGroupChangeTracker) {
                    console.debug('Input group change tracker not found for input group: ', panel.id);
                    return null;
                }

                return (
                    <ContractComparisonPanelRenderer
                        key={panel.id}
                        panelId={panel.id}
                        panelName={panel.name}
                        nodeId={nodeId}
                        inputIds={panel.inputIds}
                        inputGroupChangeTracker={inputGroupChangeTracker}
                        getNewInputById={getNewInputById}
                        getPreviousInputById={getPreviousInputById}
                    />
                );
            })}
        </>
    );
};

export default observer(ContractComparisonPanelsRenderer);
